module.exports = __webpack_public_path__ + "img/code-compare.7aff0ce9.svg";